import "./new-commodities-modal.css";

import { useContext, useState } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import type {
	HandlingUnit,
	OnChange,
} from "~/shared/types/quote-details-types";
import {
	calculateItemDensity,
	getEstClass,
} from "~/shared/utils/commodity-utils.ts";

import { CommodityHandlingUnit } from "./commodity-handling-unit.tsx";

type NewCommoditiesModalProps = {
	onClose: () => void;
	customerId?: number;
};

export const NewCommoditiesModal = ({
	onClose,
	customerId,
}: NewCommoditiesModalProps) => {
	const isMobile = useIsMobile();
	const context = useContext(QuoteDetailsContext);
	const measuringType = context?.quoteState?.measuringType ?? "LB/IN";
	const weightLabel =
		measuringType === "KG/CM" ? "Weight (kg)" : "Weight (lbs)";

	const [handlingUnit, setHandlingUnit] = useState<HandlingUnit>(() => ({
		id: 0,
		name: "",
		description: "",
		quantity: null,
		unit: {
			id: 6,
			name: "Pallets",
			code: "PLT",
		},
		weight: null,
		density: 0,
		dimensionLength: null,
		dimensionWidth: null,
		dimensionHeight: null,
		class: {
			id: "",
			name: "",
			code: "",
		},
		nmfc: "",
		isHazmat: false,
		isStackable: false,
		pieceCount: null,
		width: null,
		height: null,
		length: null,
		estClass: 0,
	}));

	const updateItem = (
		item: HandlingUnit,
		field: keyof HandlingUnit,
		value: OnChange | null,
	) => {
		setHandlingUnit((prev) => {
			const updated = {
				...prev,
				[field]: value,
			};

			if (
				field === "quantity" ||
				field === "weight" ||
				field === "length" ||
				field === "width" ||
				field === "height"
			) {
				updated.density = calculateItemDensity(updated, measuringType);
				updated.estClass = getEstClass(updated.density);
			}

			return updated;
		});
	};

	const resetForm = () => {
		onClose();
	};

	return (
		<TraxModal
			className={"new-commodity-modal"}
			onClose={onClose}
			title={isMobile ? "Add New Commodity" : "Add Item(s)"}
			type={"primary"}
			width={isMobile ? "100%" : undefined}
		>
			<CommodityHandlingUnit
				customerId={customerId}
				data-testid={"commodity-handling-unit-root"}
				handlingUnit={handlingUnit}
				hideRemoveButton={isMobile}
				idx={0}
				isSingular={true}
				onCancel={isMobile ? onClose : undefined}
				onRemoveOverride={onClose}
				onSavingEnd={resetForm}
				saveButtonLabel={isMobile ? "Add" : "Save"}
				updateItem={updateItem}
				weightLabel={isMobile ? weightLabel : undefined}
			/>
		</TraxModal>
	);
};
